import React from "react";
import CompanyProfile from "../components/CompanyProfile";

function CompanyProfilePage() {
    return (
      <>
        <CompanyProfile />
      </>
    );
  };
  
export default CompanyProfilePage;